export default __webpack_public_path__ + "static/media/logo-oca-white.40e217f9.svg";